import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatInputModule } from '@angular/material/input';
import { RouterModule } from '@angular/router';
import { TrendencyTranslationsChildModule } from '@trendency/translations';
import { TrendencyFormModule } from '../../../../trendency/form';
import { SharedModule } from '../../shared/shared.module';
import { GinopDetailsComponent } from './components/ginop-details/ginop-details.component';
import { GinopListComponent } from './components/ginop-list/ginop-list.component';
import { GinopRegistrationComponent } from './components/ginop-registration/ginop-registration.component';
import { GinopEventResolver } from './ginop-event.resolver';
import { GinopHomeResolver } from './ginop-home.resolver';
import { GinopComponent } from './ginop.component';
import { GinopRouting } from './ginop.routing';

@NgModule({
  declarations: [GinopComponent, GinopListComponent, GinopDetailsComponent, GinopRegistrationComponent],
  imports: [
    RouterModule.forChild(GinopRouting),
    TrendencyTranslationsChildModule.forChild(GinopRouting),
    CommonModule,
    SharedModule,
    MatInputModule,
    TrendencyFormModule,
  ],
  exports: [],
  providers: [GinopEventResolver, GinopHomeResolver],
})
export class GinopModule {}
